import { createOutlineIcon } from "../createIcon";

export const ChevronLeftOutlineIcon = createOutlineIcon(
  <>
    <path d="m15 17-5-5 5-5" />
  </>,
  "ChevronLeftOutlineIcon"
);
